import {Component, OnInit, ViewChild} from '@angular/core';
import {Title} from "@angular/platform-browser";
import {NzModalService} from "ng-zorro-antd";
import {HttpCommonService} from "../../services/http-common.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-enterp-employees',
  templateUrl: './enterp-employees.component.html',
  styleUrls: ['./enterp-employees.component.css']
})
export class EnterpEmployeesComponent implements OnInit {

  //企业框
  @ViewChild('searchBox') searchBox;

  searchResult: any;

  searchMsg = '请输入选择企业查询内容';

  userId: any;
  userName: any;
  fromType: any;

  constructor(private titleService: Title, private httpService: HttpCommonService,
              private showAlert: NzModalService, private routerInfo: ActivatedRoute) {
    this.userId = this.routerInfo.snapshot.queryParams['userId'];
    this.userName = this.routerInfo.snapshot.queryParams['userName'];
    this.fromType = this.routerInfo.snapshot.queryParams['fromType'];
  }

  ngOnInit() {
    this.titleService.setTitle('董监高信息查询');
  }

  searchValue() {
    if (!this.searchBox.company || !this.searchBox.keyWord) {
      this.showAlert.error({content: '请选择企业！', width: '300px', okText: '确认'});
      return;
    }
    if (this.searchBox.keyWord != this.searchBox.company.companyName) {
      this.showAlert.error({content: '请正确选择企业名称！', width: '300px', okText: '确认'});
      return;
    }
    this.searchMsg = '查询中...';
    this.httpService.get('/enterprise/detail/xhsRest/baseByQi/getCompanyEmployees',
      {companyId:this.searchBox.company.id}).subscribe(result => {
      if (result.stateCode == '60111') {
        // console.log(result.data);
        this.searchResult = result.data;
      } else {
        this.searchMsg = '查询无结果';
      }
    });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-employees/enterp-employees.component.ts